/* page-header JavaScript/jQuery */
jQuery(function( $ ) {

    // play the video
    if ( $( '#page-header' ).find( 'video' ).length ) {
        $( '#page-header' ).find( 'video' ).get( 0 ).play();
    }


    // Resize interior page header to fit contents
    function resizePageHeaderToFitContents() {
        let pageHeader          = $( '#page-header' ),
            pageHeaderContent   = pageHeader.find( '.page-header-content' );

        // remove previously set height
        pageHeader.css( 'height', '' );

        let pageHeaderHeight        = parseInt( pageHeader.css( 'height' ) ),
            pageHeaderContentHeight = parseInt( pageHeaderContent.css( 'height' ) );

        if ( pageHeaderContentHeight > pageHeaderHeight ) {
            pageHeader.css( 'height', pageHeaderContentHeight + 'px' );
        }

    }

    resizePageHeaderToFitContents();

    $( window ).on( 'resize', resizePageHeaderToFitContents );


});
